import { render, staticRenderFns } from "./TaskTemplateModal.vue?vue&type=template&id=431467f0&scoped=true&"
import script from "./TaskTemplateModal.vue?vue&type=script&lang=js&"
export * from "./TaskTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431467f0",
  null
  
)

export default component.exports